import React, { useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../CustomButton';
import '../../../common/MobileGridCards.sass';

const FIXED_FIELD_NAMES = [
	'Group', 'High G-Force', 'Max Speed',
	'Driver Event', 'Custom Clip', 'Flood', 'Sensor', 'Harsh Braking', 'Harsh Acceleration',
	'Distraction', 'Drowsiness/Head Down', 'Phone Use/Hand to Head', 'Yawning', 'Seatbelt',
	'Smoking', 'Forward Collision', 'Headway Warning', 'Lane Departure', 'Pedestrian Warning', 'Tailgating',
];

const ADDITIONAL_FIELDS = [
	'Custom Clip', 'Flood', 'Sensor', 'Harsh Braking', 'Harsh Acceleration',
	'Distraction', 'Drowsiness/Head Down', 'Phone Use/Hand to Head', 'Yawning', 'Seatbelt',
	'Smoking', 'Forward Collision', 'Headway Warning', 'Lane Departure', 'Pedestrian Warning', 'Tailgating',
];

const GroupEventBreakdownMobileCard = ({ row, columns = [] }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });
	const [showMore, setShowMore] = useState(false);

	const nameLabel = row.vehicle_group || '[Unnamed]';

	const baseData = [
		{ label: t(('High G-Force').replace(/\s/g, '_')), value: row['High G-Force'] },
		{ label: t(('Max Speed').replace(/\s/g, '_')), value: row['Max Speed'] },
		{ label: t(('Driver Event').replace(/\s/g, '_')), value: row['Driver Event'] },
	];

	const additionalData = ADDITIONAL_FIELDS.map((field) => ({
		label: t(field.replace(/\s/g, '_')),
		value: row[field],
	}));

	const seeMoreData = columns
		.filter((column) => !FIXED_FIELD_NAMES.includes(column.name))
		.map((column) => ({
			label: t(column.name.replace(/\s/g, '_')),
			value: row[column.dataField],
		}));

	return (
		<Card className="mobile-grid-card mobile-accordion-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						<span className="mobile-card-name">{nameLabel}</span>
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
							</div>
						))}
					</div>
				</div>
				<Accordion>
					<Accordion.Item eventKey="0">
						<Accordion.Header className="mobile-card-toggle" />
						<Accordion.Body>
							<div className="mobile-card-data">
								{additionalData.map(({ label, value }) => (
									<div className="mobile-card-data-item" key={label}>
										<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
									</div>
								))}
								{showMore && seeMoreData.map(({ label, value }) => (
									<div className="mobile-card-data-item" key={label}>
										<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
									</div>
								))}
							</div>
							{!!seeMoreData.length && (
								<div className="asset-log-links">
									<div className="mobile-card-data-item">
										<CustomButton variant="link" onClick={() => setShowMore(!showMore)}>
											{showMore ? t('seeLess') : t('seeMore')}
										</CustomButton>
									</div>
								</div>
							)}
						</Accordion.Body>
					</Accordion.Item>
				</Accordion>
			</Card.Body>
		</Card>
	);
};

export default GroupEventBreakdownMobileCard;
